var exports = {
  "O": "xfd349460--aa5906--underground",
  "d": "xfd349460--aa5906--underground-station",
};

module.exports = exports;
